//** Listagem das Mensagens do Fórum Relacionadas ao Usuário Logado  */

import ListaForumMinhasMensagens from "../../componentes/ListaForumMinhasMensagens";

const ListagemForumMinhasMensagens = () => {
    return (
       <div>
            <div className="container-fluid mt-3">
                <ListaForumMinhasMensagens />
            </div>
        </div>
    );
}

export default ListagemForumMinhasMensagens;